module.exports = {
    common: {
        requestProcessFail: 'Xử lý yêu cầu thất bại',
        requestFail: 'Yêu cầu thất bại',
        networkError: 'Yêu cầu mạng thất bại, vui lòng thử lại sau',
        notFound: 'Không tìm thấy địa chỉ yêu cầu',
        serverError: 'Lỗi máy chủ nội bộ',
        selectCountry: 'Vui lòng chọn quốc gia',
        confirmed: 'Đã xác nhận',
        cancelled: 'Đã hủy...',
        back: 'Quay lại',
    },

    homePage: {
        alreadyUse: 'Đã sử dụng',
        remain: 'Còn lại',
        search: 'Tìm kiếm',
        findIccid: 'Cách tìm ICCID',
        fillIccid: 'Nhập số SIM Card ICCID',
        changeLanguage: 'Chuyển ngôn ngữ',
        confirm: 'Xác nhận',
        selectLanguage: 'Vui lòng chọn ngôn ngữ',
        selectImageFile: 'Vui lòng chọn tệp hình ảnh',
        processing: 'Đang xử lý...',
        recognizeSuccess: 'Nhận diện thành công',
        recognizeFail: 'Nhận diện thất bại, vui lòng thử lại',
        recognizeEmpty: 'Không nhận diện được ICCID',
        compressFail: 'Nén thất bại',
        takePhoto: 'Chụp ảnh',
        fromAlbum: 'Chọn từ album',
        recognizing: 'Đang nhận diện...',
        openingCamera: 'Đang mở máy ảnh...',
        cameraFail: 'Không thể mở máy ảnh',
        scanFail: 'Nhận diện thất bại. Vui lòng hướng vào mã QR',
    },
    planPage: {
        contact: 'Liên hệ',
        expireNotify: 'Bạn sẽ không thể kiểm tra thông tin gói lưu lượng sau khi hết hạn gói cước. Vui lòng gia hạn kịp thời.',
        dataUsed: 'Lưu lượng đã dùng',
        dataRemain: 'Lưu lượng còn lại',
        planStatus: 'Trạng thái gói cước',
        planAutoRenew: 'Tự động gia hạn',
        planOrders: 'Chi tiết đơn hàng',
        planCountry: 'Quốc gia',
        planPackage: 'Gói cước',
        realPakcage: '9.9 Rm / 30 Ngày',
        autoRenewNotify: 'Gia hạn gói mỗi 30 ngày với 9.90Rm, có thể hủy bất cứ lúc nào.',
        goForPurchase: 'Đặt mua ngay',
        every: 'Mọi',
        days: 'bầu trời',
        lifetimeFreeFlow: 'Data miễn phí trọn đời',
        renew: 'Gia hạn gói, hủy bất cứ lúc nào',
        detail: 'Chi tiết',
        nodata: 'Không có gói',
        autoRenewSaying: 'Tuyên bố gia hạn tự động',
        autoRenewSay1: 'Bạn có thể hủy gia hạn tự động bất cứ lúc nào và sẽ không có thêm khoản phí nào được tính sau khi hủy.',
        autoRenewSay2: 'Tận hưởng mức giá siêu thấp.',
        renewNoticeTitle: 'Lưu ý quan trọng',
        renewNotice1: 'Gói cước của bạn sẽ được kích hoạt ngay sau khi thanh toán thành công.',
        renewNotice2: 'Đây là gói đăng ký tự động gia hạn. Vui lòng xem kỹ thông tin trước khi mua.',
        agreePrefix: 'Bằng việc tiếp tục, bạn đồng ý với ',
        subscribePolicy: 'Chính sách đăng ký',
        agreeMiddle: ' và ',
        refundPolicy: 'Chính sách hoàn tiền',
        agreeSuffix: '.',
        close: 'đóng cửa',
        subscription: 'Hủy đăng ký',
        cancelSubscription: 'Xác nhận hủy đăng ký？',
        conform: 'xác nhận',
        cancel: 'Hủy bỏ',
        Unlimited: 'Không giới hạn',
        cardLeftTip: '360+180 ngày',
        cardLeftTip270: '180+90 ngày',
        purchaseTitle: 'Mua gói cước'
    },
    couponRedeem: {
        title: 'Phiếu gia hạn độc quyền',
        titleNewbie: 'Phiếu ưu đãi dành riêng cho người mới',
        subtitle: 'Cảm ơn bạn đã đồng hành!',
        bullet1: 'Giới hạn một phiếu cho mỗi ICCID',
        bullet2: 'Có hiệu lực đến {date}',
        bullet3: 'Chỉ một lần duy nhất!',
        claimNow: 'Nhận ngay',
        goToUse: 'Sử dụng',
        receiveSuccess: 'Đã nhận thành công',
        receiveMissing: 'Phiếu giảm giá hoặc ICCID không hợp lệ.',
        useToast: 'Vui lòng sử dụng phiếu khi thanh toán gói cước.',
        claimToast: 'Vui lòng liên hệ hỗ trợ để hoàn tất đổi thưởng.',
        empty: 'Chưa có phiếu giảm giá',
        noCouponMsg: 'Không có phiếu giảm giá',
        buyDirect: 'Mua ngay',
        loading: 'Đang tải...',
    },
    payPage: {
        paymentConfirm: 'Payment Confirm',
        payContact: 'Liên hệ',
        payPackage: 'Gói cước',
        payDuration: 'Thời lượng',
        payTotal: 'Tổng thanh toán',
        paySelectPayment: 'Chọn phương thức thanh toán',
        payCard: 'Thẻ',
        cardDesc: 'Chỉ hỗ trợ đăng ký',
        payCardBankCredit: 'Thẻ ngân hàng / Tín dụng',
        cardSupportHint: 'Hỗ trợ Visa, Mastercard, Apple Pay, Google Pay',
        currentSelected: 'Đang chọn',
        autoBadge: 'Tự động',
        subscribeCardDeduct: 'Đăng ký trừ tiền thẻ tín dụng/ghi nợ',
        subscribeEwalletDeduct: 'Đăng ký trừ tiền ví điện tử',
        payOnceTitle: 'Thanh toán một lần',
        payOnceDesc: 'Thanh toán một lần, không tự động gia hạn; mỗi dòng một phương thức.',
        rechargeEwalletDesc: 'Thanh toán một lần qua ví điện tử',
        rechargeQrisDesc: 'Thanh toán quét mã',
        rechargeBankDesc: 'Thanh toán một lần chuyển khoản ngân hàng',
        rechargeRetailDesc: 'Thanh toán tại cửa hàng tiện lợi',
        payEWallet: 'Ví điện tử',
        payComfirm: 'Xác nhận thanh toán',
        paymentSecureHint: 'Thông tin thanh toán của bạn được bảo mật và mã hóa.',
        inputContact: 'Vui lòng nhập thông tin liên lạc',
        contactAppNumber: 'Số {app}',
        contactUpdateViaApp: 'Cập nhật đơn hàng sẽ được gửi qua {app}',
        contactPhonePlaceholder: 'Vui lòng nhập số',
        contactPhoneMinLength: 'Vui lòng nhập ít nhất 8 chữ số',
        orderCouponLoading: 'Đang tải phiếu giảm giá...',
        couponAppliedSub: 'Đã áp dụng cho đơn hàng này',
        couponAvailableSub: 'Có thể dùng cho đơn hàng này',
        couponDeductLabel: 'Giảm giá phiếu',
        amountAfterDeduction: 'Số tiền sau khấu trừ',
        subscribeDetailTitle: 'Chi tiết đăng ký (Tự động gia hạn)',
        subscribeDetailSubtitle: 'Xem chu kỳ thanh toán, quy tắc gia hạn, hủy đăng ký và hơn thế nữa',
        subscribeDetailIntro: 'Đây là gói đăng ký tự động gia hạn. Bằng việc tiếp tục, bạn đồng ý với các điều khoản bên dưới.',
        subscribeBillingCycle: 'Chu kỳ thanh toán',
        subscribeBillingCycleVal: 'Mỗi {days} ngày',
        subscribeAmount: 'Số tiền',
        subscribeAmountVal: '{amount} / {days} ngày',
        subscribeNextRenewal: 'Gia hạn tiếp theo',
        subscribeNextRenewalVal: 'Vào ngày hết hạn, số tiền sẽ được tự động trừ.',
        subscribePaymentMethod: 'Phương thức thanh toán',
        subscribePaymentMethodVal: 'Các lần gia hạn sau sẽ được trừ qua phương thức thanh toán này.',
        subscribeCancelAnytime: 'Hủy bất cứ lúc nào',
        subscribeCancelAnytimeVal: 'Bạn có thể hủy tự động gia hạn trước ngày thanh toán tiếp theo. Sau khi hủy, gói cước vẫn hoạt động đến khi hết hạn.',
        subscribeActivation: 'Kích hoạt',
        subscribeActivationVal: 'Gói cước sẽ được kích hoạt ngay sau khi thanh toán thành công.',
        refundSummaryTitle: 'Chính sách hoàn tiền (Tóm tắt)',
        refundSummarySubtitle: 'Xem điều kiện hoàn tiền, quy trình và ngoại lệ',
        refundSummaryIntro: 'Hoàn tiền chỉ áp dụng trong các trường hợp sau:',
        refundSummaryCase1: 'Thanh toán trùng lặp',
        refundSummaryCase2: 'Thanh toán thành công nhưng gói chưa được kích hoạt',
        refundSummaryCase3: 'Sự cố kỹ thuật do Franwell gây ra',
        refundSummaryDisclaimer: 'Không hoàn tiền khi gói đã được kích hoạt thành công hoặc đã sử dụng một phần.',
        refundSummaryLink: 'Xem chính sách hoàn tiền đầy đủ',
        agreeAutoRenew: 'Tôi hiểu đây là gói đăng ký tự động gia hạn và đồng ý với các điều khoản ở trên.',
        agreePoliciesPrefix: 'Tôi đã đọc và đồng ý với ',
        agreeAutoRenewRequired: 'Vui lòng xác nhận điều khoản đăng ký tự động gia hạn.',
        agreePoliciesRequired: 'Vui lòng đồng ý với Chính sách đăng ký và Chính sách hoàn tiền.',
        agreeConsentRequired: 'Vui lòng chọn các ô đồng ý phía trên.',
        subscribePolicyPopupTitle: 'Chính sách đăng ký',
        subscribePolicySection1Title: '1. Đăng ký',
        subscribePolicyS1Item1: 'Gói đăng ký của bạn sẽ bắt đầu ngay sau khi thanh toán thành công.',
        subscribePolicyS1Item2: 'Mỗi gói đăng ký có hiệu lực trong {days} ngày.',
        subscribePolicyS1Item3: 'Gói đăng ký của bạn sẽ tự động gia hạn mỗi {days} ngày.',
        subscribePolicyS1Item4: 'Số tiền gia hạn là {amount} cho mỗi {days} ngày.',
        subscribePolicyS1Item5: 'Thanh toán gia hạn sẽ được tự động trừ vào phương thức thanh toán bạn đã chọn.',
        subscribePolicyS1Item6: 'Bạn có thể hủy tự động gia hạn bất cứ lúc nào trước ngày thanh toán tiếp theo.',
        subscribePolicyS1Item7: 'Sau khi hủy, gói đăng ký hiện tại vẫn hoạt động cho đến khi hết hạn.',
        subscribePolicySection2Title: 'Hướng dẫn hủy đăng ký',
        subscribePolicyS2Step1Label: 'Bước 1',
        subscribePolicyS2Step1: 'Vào trang 4G',
        subscribePolicyS2Step2Label: 'Bước 2',
        subscribePolicyS2Step2: 'Tìm nút đăng ký',
        subscribePolicyS2Step3Label: 'Bước 3',
        subscribePolicyS2Step3: 'Nhấn "Tắt tự động gia hạn"',
        subscribePolicyS2Step4Label: 'Bước 4',
        subscribePolicyS2Step4: 'Xác nhận hủy',
        subscribePolicyS2Tip: 'Bạn vẫn có thể sử dụng dịch vụ này bình thường cho đến khi kết thúc chu kỳ đăng ký hiện tại.',
        subscribePolicyFullLink: 'Xem chính sách đăng ký đầy đủ',
        xenditSubscribeNoticeTitle: 'Lưu ý quan trọng',
        xenditSubscribeNotice1: 'Bạn đang đăng ký trong khoảng từ ngày 29 đến 31.',
        xenditSubscribeNotice2Prefix: 'Đăng ký của bạn sẽ thành công, nhưng việc thanh toán thực tế sẽ được hoãn đến ',
        xenditSubscribeNotice2Highlight: 'ngày 1 của tháng sau.',
        xenditSubscribeNotice3: 'Chúng tôi sẽ cung cấp cho bạn các ngày sử dụng miễn phí trong thời gian này. Sau khi thanh toán được trừ, số ngày gói cước của bạn sẽ được gia hạn tự động.',
        xenditSubscribeNoticeConfirm: 'Đã hiểu',
        refundPolicyPopupTitle: 'Chính sách hoàn tiền',
        refundPolicySection1Title: '1. Đủ điều kiện hoàn tiền',
        refundPolicyS1Intro: 'Hoàn tiền sẽ được cung cấp trong các trường hợp sau:',
        refundPolicyS1Item1: 'Thanh toán trùng lặp',
        refundPolicyS1Item2: 'Thanh toán thành công nhưng gói chưa được kích hoạt',
        refundPolicyS1Item3: 'Sự cố kỹ thuật do Franwell gây ra',
        refundPolicySection2Title: '2. Không đủ điều kiện hoàn tiền',
        refundPolicyS2Intro: 'Hoàn tiền sẽ không được cung cấp trong các trường hợp sau:',
        refundPolicyS2Item1: 'SIM đã được kích hoạt và dịch vụ dữ liệu đã được sử dụng',
        refundPolicyS2Item2: 'Sử dụng một phần hoặc toàn bộ gói',
        refundPolicyS2Item3: 'Thay đổi ý định sau khi mua',
        refundPolicyS2Item4: 'Vấn đề về vùng phủ sóng hoặc tín hiệu sau khi kích hoạt thành công',
        refundPolicySection3Title: '3. Quy trình hoàn tiền',
        refundPolicyS3Item1: 'Hoàn tiền sẽ được xử lý trong vòng 3-5 ngày làm việc.',
        refundPolicyS3Item2: 'Tiền hoàn sẽ được trả về phương thức thanh toán ban đầu.',
        selectPaymentRequired: 'Vui lòng chọn phương thức thanh toán',
        paymentLinkInvalid: 'Liên kết thanh toán không hợp lệ',
        redirectPaymentFailed: 'Không thể mở trang thanh toán. Vui lòng thử lại thủ công.',
        createOrderFailed: 'Tạo đơn hàng thất bại',
        creatingOrder: 'Đang tạo đơn hàng thanh toán...',
        paymentComponentLoadFailedRefresh: 'Tải thành phần thanh toán thất bại. Vui lòng làm mới trang.',
        paymentComponentLoadFailed: 'Tải thành phần thanh toán thất bại',
        paymentFailed: 'Thanh toán thất bại',
        paymentCancelled: 'Đã hủy thanh toán',
        paymentInitFailed: 'Khởi tạo thanh toán thất bại',
        indonesiaPhoneInvalid: 'Định dạng không hợp lệ. Vui lòng nhập số điện thoại Indonesia hợp lệ',
    },
    paySuccessPage: {
        pendingResult: 'Kết quả đơn hàng đang chờ',
        activationSuccess: 'Kích hoạt SIM của bạn đã được gửi thành công',
        activationQuery: 'Truy vấn trạng thái kích hoạt',
        pendingPaymentTitle: 'Đơn hàng chờ thanh toán',
        orderNoLabel: 'Mã đơn hàng',
        redirectingPayment: 'Đang chuyển đến trang thanh toán...',
        pay: 'Thanh toán',
        orderNoMissing: 'Thiếu mã đơn hàng',
        paymentLinkInvalid: 'Liên kết thanh toán không hợp lệ',
    },
    orderPage: {
        orderRecords: 'Order Records',
        activated: 'Đã kích hoạt',
        notActivated: 'Chưa kích hoạt',
        closed: 'Đã đóng',
        activateFailed: 'Kích hoạt thất bại',
        paySuccess: 'Thành công',
        payFailed: 'Thất bại',
        notPaid: 'Chưa thanh toán',
        refunded: 'Đã hoàn tiền',
        Pending: 'Đang chờ',
        orderRecord: 'Lịch sử đơn hàng',
        orderStatus: 'Trạng thái đơn',
        orderPayStatus: 'Trạng thái thanh toán',
        orderCountry: 'Quốc gia',
        orderPackage: 'Gói cước',
        orderIccid: 'ICCID',
        orderOrderTime: 'Thời gian đặt hàng',
        back: 'quay lại'
    },
    deviceInfo: {
        title: 'Thông tin thiết bị',
        userId: 'ID người dùng',
        deviceId: 'ID thiết bị',
        operatorAlertTitle: 'Thông báo mở khóa',
        operatorAlert:
            'Thiết bị này đã nhận được trợ giá chính thức với mức giá ưu đãi hơn và đi kèm thẻ SIM 4G chính thức để mang lại trải nghiệm sử dụng tốt nhất. Nếu bạn muốn gỡ bỏ các hạn chế, bạn có thể chọn mở khóa với một khoản phí. Sau khi mở khóa, bạn có thể sử dụng các thẻ SIM tương thích khác.',
        unlockPermanent: 'Mở khóa vĩnh viễn',
        unlockDescription: 'Thanh toán một lần, mở khóa thiết bị vĩnh viễn',
        unlockDescription01: 'Sau khi mở khóa, bạn có thể sử dụng SIM của bất kỳ nhà mạng nào.',
        unlockImmediate: 'Mở khóa ngay',
        noticeTitle: 'Hướng dẫn mở khóa',
        unlockNotice:
            'Lưu ý: Nếu bạn đã thanh toán, quá trình mở khóa sẽ có hiệu lực trong vòng 5–10 phút. Vui lòng giữ kết nối mạng và thử lại sau.'
    },

    deviceUnlockPaymentInfo: {
        title: 'Thông tin thiết bị',
        userId: 'ID người dùng',
        deviceId: 'ID thiết bị',
        total: 'Tổng cộng',
        paySelectPayment: 'Chọn phương thức thanh toán',
        payCard: 'Thẻ',
        payEWallet: 'Ví điện tử',
        payConfirm: 'Xác nhận thanh toán',
        operatorAlert:
            'Thiết bị này đã nhận được trợ giá chính thức với mức giá ưu đãi hơn và đi kèm thẻ SIM 4G chính thức để mang lại trải nghiệm sử dụng tốt nhất. Nếu bạn muốn gỡ bỏ các hạn chế, bạn có thể chọn mở khóa với một khoản phí. Sau khi mở khóa, bạn có thể sử dụng các thẻ SIM tương thích khác.',
        unlockPermanent: 'Mở khóa vĩnh viễn',
        unlockDescription: 'Thanh toán một lần, mở khóa thiết bị vĩnh viễn',
        unlockDescription01: 'Sau khi mở khóa, bạn có thể sử dụng SIM của bất kỳ nhà mạng nào.',
        unlockImmediate: 'Mở khóa ngay',
        noticeTitle: 'Hướng dẫn mở khóa',
        unlockNotice:
            'Lưu ý: Nếu bạn đã thanh toán, quá trình mở khóa sẽ có hiệu lực trong vòng 5–10 phút. Vui lòng giữ kết nối mạng và thử lại sau.',
        unlockConfirm: 'Xác nhận',
        unlockRequestFail: 'Yêu cầu thất bại',
        unlockTipsTitle: 'Mẹo',
        unlockedMsg: 'Sản phẩm này đã được mở khóa, không cần thực hiện lại!',
        UnlockSuccessful: 'Chúc mừng! Mở khóa thành công!'
    },
    feedbackPage: {
        title: 'Phản hồi',
        heroTitle: 'Hãy cho chúng tôi biết chuyện gì đã xảy ra',
        heroSubtitle: 'Chúng tôi sẽ hỗ trợ bạn sớm nhất có thể.',
        ticketHistory: 'Lịch sử phiếu của tôi',
        problemCategory: 'Danh mục vấn đề',
        issueSelectTitle: 'Vui lòng chọn vấn đề cụ thể',
        issueSelectSubtitle: 'Chọn mục phù hợp nhất với tình huống của bạn.',
        next: 'Tiếp theo',
        form: {
            describeTitle: 'Mô tả vấn đề của bạn',
            describeSubtitle: 'Vui lòng cung cấp thêm chi tiết về vấn đề bạn đang gặp phải.',
            describePlaceholder: 'Vui lòng mô tả vấn đề tại đây... (Tối đa 500 ký tự)',
            uploadPhotoTitle: 'Tải ảnh lên (Tùy chọn)',
            uploadPhotoSubtitle: 'Bạn có thể tải lên tối đa 3 ảnh',
            uploadScreenshotTitle: 'Tải ảnh chụp màn hình (Tùy chọn)',
            uploadScreenshotSubtitle: 'Giúp chúng tôi hiểu vấn đề tốt hơn',
            contactEmailTitle: 'Email liên hệ',
            contactEmailPlaceholder: 'example@email.com',
            orderNoTitle: 'Mã đơn hàng',
            orderNoPlaceholder: 'Vui lòng nhập mã đơn hàng',
            orderNoRequired: 'Vui lòng nhập mã đơn hàng',
            takePhoto: 'Chụp ảnh',
            chooseFromAlbum: 'Chọn từ thư viện',
            cancel: 'Hủy',
            emailRequired: 'Vui lòng nhập email liên hệ',
            emailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ',
            describeRequired: 'Vui lòng mô tả vấn đề của bạn',
            uploading: 'Đang tải lên...',
            uploadFailed: 'Tải ảnh thất bại, vui lòng thử lại',
            submitting: 'Đang gửi...',
            submitFailed: 'Gửi thất bại, vui lòng thử lại',
            confirmSelected: 'Bạn đã chọn:',
            pleaseMakeSure: 'Vui lòng đảm bảo:',
            checkSimInserted: 'Thẻ SIM được lắp đúng cách',
            checkDataPlanActive: 'Gói dữ liệu của bạn đang hoạt động',
            checkCameraPowered: 'Camera đang bật nguồn',
            checkSignalStrength: 'Cường độ tín hiệu ít nhất 2 vạch',
            checkRestartCamera: 'Thử khởi động lại camera',
            confirmPrompt: 'Vui lòng xác nhận các vấn đề trên',
            submit: 'Gửi',
        },
        success: {
            title: 'Gửi thành công!',
            subtitle: 'Đội ngũ hỗ trợ đã nhận được yêu cầu của bạn.',
            ticketNumber: 'Số phiếu',
            submitTime: 'Thời gian gửi',
            responseTime: 'Chúng tôi sẽ phản hồi trong vòng 24 giờ (ngày làm việc).',
            statusCheck: 'Bạn có thể kiểm tra trạng thái trong "Phiếu của tôi".',
            myTickets: 'Phiếu của tôi',
            backToHome: 'Về trang chủ',
            copySuccess: 'Đã sao chép',
        },
        categories: {
            camera: { title: 'Camera', desc: 'Camera offline, không xem được, lỗi chế độ ban đêm' },
            sim: { title: 'SIM / Mạng', desc: 'Không có mạng, tín hiệu yếu, lỗi SIM' },
            recharge: { title: 'Nạp tiền / Gói cước', desc: 'Nạp thất bại, gói chưa cập nhật, hoàn tiền' },
            data: { title: 'Sử dụng dữ liệu', desc: 'Dùng nhiều dữ liệu, dữ liệu còn lại không đúng' },
            device: { title: 'Chức năng thiết bị', desc: 'Phát hiện chuyển động, lưu trữ đám mây, ghi hình' },
            order: { title: 'Đơn hàng & Thanh toán', desc: 'Thanh toán thất bại, hoàn tiền, hóa đơn' },
            other: { title: 'Khác', desc: 'Các vấn đề khác' },
        },
        issues: {
            camera_offline: 'Camera offline',
            cannot_view_live: 'Không xem trực tiếp được',
            playback_failed: 'Phát lại thất bại',
            night_vision: 'Lỗi chế độ ban đêm',
            motion_detection: 'Phát hiện chuyển động',
            camera_restart: 'Khởi động lại camera',
            camera_not_added: 'Chưa thêm camera',
            sim_not_activated: 'SIM chưa kích hoạt',
            no_network: 'Không có mạng',
            weak_signal: 'Tín hiệu yếu',
            roaming_issue: 'Lỗi chuyển vùng',
            sim_replacement: 'Thay SIM',
            cannot_detect_sim: 'Không nhận diện được SIM',
            '4g_not_working': '4G không hoạt động',
            recharge_failed: 'Nạp tiền thất bại',
            recharge_not_effective: 'Nạp thành công nhưng chưa có hiệu lực',
            plan_not_updated: 'Gói chưa cập nhật',
            wrong_package: 'Gói sai',
            auto_renewal: 'Gia hạn tự động',
            subscription: 'Đăng ký',
            refund: 'Hoàn tiền',
            coupon: 'Phiếu giảm giá',
            high_data_usage: 'Dùng nhiều dữ liệu',
            data_used_too_fast: 'Dùng dữ liệu quá nhanh',
            remaining_data_incorrect: 'Dữ liệu còn lại không đúng',
            usage_not_updated: 'Lượng dùng chưa cập nhật',
            need_usage_report: 'Cần báo cáo sử dụng',
            payment_failed: 'Thanh toán thất bại',
            duplicate_payment: 'Thanh toán trùng',
            order_not_found: 'Không tìm thấy đơn hàng',
            invoice: 'Hóa đơn',
            discount: 'Giảm giá',
            cloud_storage: 'Lưu trữ đám mây',
            recording: 'Ghi hình',
            sd_card: 'Thẻ SD',
            notification: 'Thông báo',
            firmware_upgrade: 'Nâng cấp firmware',
            device_binding: 'Liên kết thiết bị',
            qr_code: 'Mã QR',
            reset_device: 'Đặt lại thiết bị',
            other: 'Khác',
        },
        history: {
            tabs: {
                all: 'Tất cả',
                processing: 'Đang xử lý',
                waiting: 'Đang chờ',
                resolved: 'Đã giải quyết',
                closed: 'Đã đóng',
            },
            status: {
                processing: 'Đang xử lý',
                waiting: 'Đang chờ',
                resolved: 'Đã giải quyết',
                closed: 'Đã đóng',
            },
            deviceId: 'ID thiết bị',
            iccid: 'ICCID',
            submitTime: 'Thời gian gửi',
            empty: 'Không có phiếu nào',
            loading: 'Đang tải...',
        },
    },

    PositiveReviewCashbackPopup: {
        title: 'Get free data',
        tip: 'with a 5-star review',
        confirm: 'Claim Now'
    },

    newbieCouponPopup: {
        titleOffer: 'Ưu đãi độc quyền',
        noThreshold: 'Phiếu giảm giá không điều kiện',
        fullReduction: 'Phiếu giảm khi đủ điều kiện',
        nonSubscribeOnly: 'Chỉ dành cho gói không đăng ký',
    }
}
